module.exports = "https://static.wmbcdn.com/uniweb/images/f0167ef9fe0570fa8d62f97c6e99c2d4.svg";